module.exports = __webpack_public_path__ + "static/media/yt-zoo.195fd5ae.mov";